'use strict';

const _ = require('lodash');

function PdfPreviewController (
      $rootScope, $scope, $location, $timeout, $window, AnalyticsService,
      leafletData, Flux, IdentityService, DashDialogsActions, MapActions,
      PdfPreviewActions, sbAuth, ConversionService, $state,
      DashPdfPreviewService, ManagerPdfPreviewService) {

  const vm = this;
  const PdfPreviewStore = Flux.Store.get('PdfPreviewStore');
  const MapStore = Flux.Store.get('MapStore');
  const opacities = {
    dcOpacity: 1,
    mapOpacity: 1
  };

  // Select service based on if we are on the manager or in the map
  let PdfPreviewService;

  if ($state.includes('dash')) {
    PdfPreviewService = DashPdfPreviewService;
  }
  else if ($state.includes('manager')) {
    PdfPreviewService = ManagerPdfPreviewService;
  }
  else {
    console.error('No PdfPreviewService defined for state ', $state.current.name);
    throw 'No PdfPreviewService defined';
  }

  // Directive behavior and map properties
  vm.activeLayer = null;
  vm.bimEnabled = false;
  vm.currentAnnotations = [];
  vm.currentMeasurements = [];
  vm.currentDataCapture = [];
  vm.currentHeatMap = null;
  vm.currentOverlays = [];
  vm.currentSite = {};
  vm.downloadUrl = '';
  vm.fullSiteEnabled = false;
  vm.isAC2 = false;
  vm.isWorkday = false;
  vm.label = PdfPreviewService.getConstant('DEFAULT_LABEL');
  vm.pdfName = '';
  vm.position = PdfPreviewService.getConstant('DEFAULT_POSITION');
  vm.quality = null;
  vm.saveDestination = null;
  vm.showCancelDialog = false;
  vm.showConfirmation = false;
  vm.siteView = null;
  vm.visible = false;
  vm.zoom = null;

  /**
   * Initialize the preview map with the main map's current state
   * TODO: implement overlay and heatmap initialization
   */
  vm._initMap = () => {
    const currentSite = PdfPreviewService.getSite();
    const currentDataCapture = PdfPreviewService.getCurrentDataCapture();

    // Pull in related data export and if one exists with a valid PDF location, allow the user to download that PDF from this dialog
    if (currentDataCapture) {
      PdfPreviewService.getDirectDownloadData(currentDataCapture.id)
      .then((related) => {
        this.downloadUrl = related.downloadUrl;
        this.label = related.label;
      });
    }
    else {
      DashDialogsActions.NoDataCaptureAvailable.dispatch();
    }

    this.currentAnnotations = PdfPreviewService.getFormattedAnnotations();
    this.currentMeasurements = PdfPreviewService.getFormattedMeasurements();
    this.currentOverlays = PdfPreviewService.getFormattedOverlays();

    // Site has to be deeply cloned or else the preview map and main map will share the same location
    this.currentSite = _.clone(currentSite, true);
    this.fullSiteEnabled = PdfPreviewService.hasFullSite(currentSite);
    this.isAC2 = PdfPreviewService.isAC2(this.currentSite.slug);
    this.isWorkday = PdfPreviewService.isWorkday(this.currentSite.slug);
    this.pdfName = PdfPreviewService.getTitle(currentSite, currentDataCapture);
    this.quality = PdfPreviewService.getConstant('DEFAULT_QUALITY');
    this.saveDestination = PdfPreviewService.getConstant('DEFAULT_SAVE_DESTINATION');
    this.showConfirmation = this.showCancelDialog = PdfPreviewStore.get('showCancelDialog');
    this.siteView = PdfPreviewService.hasFullSite(currentSite) ?
        PdfPreviewService.getConstant('FULL_SITE_VIEW') :
        PdfPreviewService.getConstant('DEFAULT_SITE_VIEW');
    this.visible = PdfPreviewStore.get('dialogVisibility');

    $rootScope.$on('opacityUpdated', (event, data) => {
      opacities.dcOpacity = data.dcOpacity;
      opacities.mapOpacity = data.mapOpacity;
      MapActions.SetOpacityValues.dispatch(opacities);
    });

    this.currentDataCapture = PdfPreviewService.getFormattedDataCaptures();
    this.setupMap();
  };

  vm.cancelPDF = () => {
    PdfPreviewActions.CancelDownload.dispatch();
    this.hideModal();
  };

  vm.disable = () => this.siteView === PdfPreviewService.getConstant('FULL_SITE_VIEW');

  /**
   * Hit the export endpoint and initialize PDF processing
   */
  vm.downloadPDF = () => {
    if (PdfPreviewService.isDownloadAvailable(this.label)) {
      $window.open(this.downloadUrl);
      this.hideModal();

      return;
    }

    let bounds;
    let dbData;
    let pdfData;
    let quality;
    const autodesk = this.saveDestination === PdfPreviewService.getConstant('AUTODESK_SAVE_DESTINATION');
    const filename = PdfPreviewService.createFileName(this.pdfName);
    const isFullSite = (PdfPreviewService.isFullSiteSelected(this.siteView)) && (this.isAC2);

    leafletData.getMap('preview').then((map) => {
      if (PdfPreviewService.isFullSiteSelected(this.siteView) && this.isWorkday) {
        bounds = PdfPreviewService.createFullSiteBoundsForWorkday(this.currentDataCapture[0]);
        quality = 'high';
      } else {
        bounds = PdfPreviewService.getBounds(map);
      }

      // define pdf object for the processing job
      pdfData = {
        annotations: PdfPreviewService.sanitizeResource(this.currentAnnotations),
        autodesk,
        bounds,
        boxFolderId: '',
        dataCapture: PdfPreviewService.sanitizeResource(this.currentDataCapture),
        dcOpacity: opacities.dcOpacity,
        filename,
        fullSite: isFullSite,
        heatmap: this.currentHeatmap,
        isMetric: ConversionService.isMetric(),
        layers: [],
        mapOpacity: opacities.mapOpacity,
        maxZoom: PdfPreviewService.getConstant('MAX_ZOOM'),
        measurements: PdfPreviewService.sanitizeResource(this.currentMeasurements),
        origin: PdfPreviewService.getConstant('ORIGIN'),
        overlays: PdfPreviewService.sanitizeResource(this.currentOverlays),
        quality: quality || this.quality,
        site: PdfPreviewService.sanitizeResource(this.currentSite),
        title: this.pdfName
      };

      // define data_exports object for mySQL DB
      dbData = {
        formula: pdfData,
        type: PdfPreviewService.getConstant('PDF_TYPE'),
        userId: IdentityService.getUser().id
      };

      PdfPreviewService.sendAnalytics(pdfData);
      PdfPreviewActions.ProcessPdf.dispatch(dbData);

      this.hideModal();
    });
  };

  vm.getResourceProxyAuth = () => {
    const resourceProxyUri = IdentityService.getResourceProxyUri();

    return sbAuth.getToken().then((token) => {
      return {
        resourceProxyUri,
        token
      };
    });
  };

  vm.hideModal = () => {
    PdfPreviewActions.HidePdfPreview.dispatch();
    this.pdfName = '';
    this.quality = null;
    this.showConfirmation = false;
  };

  vm.setCurrentView = () => {
    this.label = PdfPreviewService.getConstant('DEFAULT_LABEL');
  };

  vm.setFullSiteView = () => {
    this.label = PdfPreviewService.getConstant('DOWNLOAD_LABEL');
  };

  vm.setupMap = () => {
    // angular and leaflet are awkward together so use timeout to ensure the map initializes properly
    $timeout(() => {
      leafletData.getMap().then((map) => {
        // set layer opacities to ensure they match the base map
        opacities.dcOpacity = MapStore.get('dcOpacity') / 100;
        opacities.mapOpacity = MapStore.get('mapOpacity') / 100;
        PdfPreviewService.setOpacities(map, opacities);

        // set initial zoom level
        this.zoom = map.getZoom();

        // register listener to update zoom when it changes
        map.on('zoomend', () => {
          this.zoom = map.getZoom();
          // ensure that a previously selected radio button does not stay selected if it is disabled
          if (this.zoom > 19 && this.quality === 'high') {
            this.quality = 'normal';
          }
          else if (this.zoom > 20) {
            this.quality = 'low';
          }
        });
      });
    }, 100);
  };

  PdfPreviewStore.on(PdfPreviewStore.Events.Changed, this._initMap.bind(this), $scope);
  MapStore.on(MapStore.Events.ClearDownload, this.hideModal.bind(this), $scope);
}

PdfPreviewController.$inject = [
  '$rootScope', '$scope', '$location', '$timeout', '$window', 'AnalyticsService',
  'leafletData', 'sbFlux', 'IdentityService', 'DashDialogsActions', 'MapActions',
  'PdfPreviewActions', 'sbAuth', 'ConversionService', '$state',
  'DashPdfPreviewService', 'ManagerPdfPreviewService'
];

module.exports = PdfPreviewController;



// WEBPACK FOOTER //
// ./src/app/shared/pdfPreview/PdfPreviewController.js